var _rect, _path, _path2, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSavings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#paint0_linear_2100_4150)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9674 15.1718C28.7073 13.5546 30.3225 12.5173 32.101 12.5173H35.5429L34.557 18.2641C34.459 18.835 34.6299 19.413 34.958 19.8904C35.2226 20.2756 35.4575 20.6827 35.6592 21.1087C35.734 21.2664 35.9116 21.3449 36.0862 21.3449L39.3966 21.3449C40.006 21.3449 40.5 21.839 40.5 22.4484V26.7767C40.5 27.2787 40.161 27.7175 39.6752 27.8443L36.3649 28.7083C36.3097 28.7227 36.2646 28.7645 36.251 28.8199C35.8477 30.4642 34.9838 31.9275 33.8038 33.0653C33.2005 33.647 32.7759 34.4151 32.7759 35.2532V37.8966C32.7759 39.1155 31.7878 40.1035 30.569 40.1035H28.4058C27.3538 40.1035 26.448 39.361 26.2417 38.3295L25.6833 35.5375H18.9029L18.3445 38.3295C18.1382 39.361 17.2324 40.1035 16.1804 40.1035H14.0172C12.7984 40.1035 11.8103 39.1155 11.8103 37.8966C11.8103 35.1814 10.308 32.7133 9.22658 30.2227C8.75915 29.1462 8.5 27.9583 8.5 26.7099V24.8835C8.5 20.0082 12.4522 16.0559 17.3276 16.0559H27.5629L27.9674 15.1718Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2241 19.6898C16.2241 18.7757 16.9652 18.0347 17.8793 18.0347L24.5 18.0347C25.4141 18.0347 26.1552 18.7757 26.1552 19.6898C26.1552 20.604 25.4141 21.345 24.5 21.345L17.8793 21.345C16.9652 21.345 16.2241 20.604 16.2241 19.6898Z",
    fill: "#5FCC5B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1897,
    cy: 9.75855,
    r: 3.86207,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2100_4150",
    x1: 1.06167e-7,
    y1: 0.764664,
    x2: 49.2178,
    y2: 47.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009112"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/Savings.cb910a39a5f1595bacb65967642551ef.svg";
export { ForwardRef as ReactComponent };